{% block sw_cms_block_manufacturer_block %}
	<div>
		<slot
			name="manufacturerElement"></slot>
	</div>
{% endblock %}
